import { mapEnumToOptions } from '@abp/ng.core';

export enum ImportStatus {
  Pending = 'Pending',
  Working = 'Working',
  Completed = 'Completed',
  Failed = 'Failed',
}

export const importStatusOptions = mapEnumToOptions(ImportStatus);
